export default __webpack_public_path__ + "static/media/akcept.d3bf21b2.svg";